import React, { useState, useEffect } from 'react';
import { Monitor, Smartphone, AlertTriangle } from 'lucide-react';
import Button from '../ui/Button';

export default function MobileWarning({ children }) {
  const [isMobile, setIsMobile] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      // Detectar si es móvil o tablet (menor a 1024px)
      const isMobileDevice = window.innerWidth < 1024;
      setIsMobile(isMobileDevice);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    
    // Verificar si ya aceptó anteriormente (guardar en sessionStorage)
    const hasAccepted = sessionStorage.getItem('mobileWarningAccepted');
    if (hasAccepted === 'true') {
      setAccepted(true);
    }

    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const handleAccept = () => {
    setAccepted(true);
    sessionStorage.setItem('mobileWarningAccepted', 'true');
  };

  // Si no es móvil o ya aceptó, mostrar el contenido
  if (!isMobile || accepted) {
    return children;
  }

  // Mostrar advertencia
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-amber-50 to-orange-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 space-y-6 border border-amber-200">
        {/* Icono */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center">
              <Smartphone className="w-10 h-10 text-amber-600" />
            </div>
            <div className="absolute -top-1 -right-1 w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-white" />
            </div>
          </div>
        </div>

        {/* Título */}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-neutral-800 mb-2">
            Dispositivo Detectado
          </h2>
          <p className="text-neutral-600">
            Parece que estás usando un dispositivo móvil o tablet
          </p>
        </div>

        {/* Mensaje */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 space-y-3">
          <div className="flex items-start gap-3">
            <Monitor className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-semibold text-amber-800">
                Recomendación importante
              </p>
              <p className="text-sm text-amber-700 mt-1">
                Para una mejor experiencia al realizar los exámenes, te recomendamos utilizar un <strong>equipo de escritorio o laptop</strong>.
              </p>
            </div>
          </div>
        </div>

        {/* Razones */}
        <div className="space-y-2 text-sm text-neutral-600">
          <p className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-amber-500 rounded-full"></span>
            Mejor visualización de las imágenes
          </p>
          <p className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-amber-500 rounded-full"></span>
            Mayor comodidad para responder
          </p>
          <p className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-amber-500 rounded-full"></span>
            Menor riesgo de errores accidentales
          </p>
        </div>

        {/* Botón */}
        <Button 
          onClick={handleAccept}
          className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-3"
        >
          Entiendo, continuar
        </Button>

        <p className="text-xs text-center text-neutral-500">
          Puedes continuar, pero ten en cuenta que la experiencia puede no ser óptima
        </p>
      </div>
    </div>
  );
}
